import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = { data: Array }
  static targets = ["container"]

  connect() {
    const data = this.dataValue
    if (!data || data.length === 0) return

    this.chart = new ApexCharts(this.containerTarget, {
      chart: {
        type: "area",
        height: 40,
        sparkline: { enabled: true },
        animations: { enabled: false }
      },
      series: [{ data: data.map(d => d.pct) }],
      colors: ["#734CE0"],
      stroke: { curve: "smooth", width: 2 },
      fill: {
        type: "gradient",
        gradient: { opacityFrom: 0.3, opacityTo: 0.05 }
      },
      tooltip: {
        fixed: { enabled: false },
        x: { show: true },
        y: {
          formatter: (val) => val + "%",
          title: { formatter: () => "" }
        },
        marker: { show: false }
      },
      xaxis: { categories: data.map(d => d.month) }
    })
    this.chart.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }
}
